import { backgrounds } from './btn-bg';
const { btnBg, btnBgLong, keyMoment } = backgrounds;

export const business = `<div class="video-segments">
<div class="video-segment is-active segment-1" data-duration="27">
    <span class="video-segment_title">Prepare for Take-off</span>

    <div class="key-moment" data-timestamp="16">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-1.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-shanti-keymoment">
            ${keyMoment}
        </div>
    </div>

    <div class="interactive-point" data-timestamp="3" data-duration="5">
        <button type="button" class="btn-interactive -long" data-article-link data-article="business" data-analytics="2024-sia-video-shanti-article">
            <span class="btn-interactive_text text-center">
                Sprinting Towards <br> Success
            </span>
            ${btnBgLong}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
<div class="video-segment" data-duration="28">
    <span class="video-segment_title">Connect to the World</span>

    <span class="key-moment" data-timestamp="51">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-2.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-shanti-keymoment">
            ${keyMoment}
        </div>
    </span>

    <div class="interactive-point" data-timestamp="35" data-duration="10" data-analytics="2024-sia-video-shanti-culinary">
        <button type="button" class="btn-interactive -culinary" data-video="culinary-btn">
            <span class="btn-interactive_text">
                Culinary <br>
                Journey
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
<div class="video-segment" data-duration="11">
    <span class="video-segment_title">Cruise in Comfort</span>

    <div class="interactive-point" data-timestamp="56" data-duration="4">
        <button type="button" class="btn-interactive -culinary" data-video="aisle" data-type="business"  data-analytics="2024-sia-video-shanti-aisle">
            <span class="btn-interactive_text text-center">
                Sky-High <br>
                Comforts
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>

    <span class="key-moment" data-timestamp="62">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-3.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-shanti-keymoment">
            ${keyMoment}
        </div>
    </span>
</div>

<div class="video-segment segment-4" data-duration="9.69">
    <span class="video-segment_title">Experience Singapore Airlines </span>

    <div class="interactive-point " data-timestamp="70" data-duration="5">
        <button type="button" class="btn-interactive -article -long" data-article-link data-article="business" data-analytics="2024-sia-video-shanti-article">
            <span class="btn-interactive_text text-center">
                Sprinting Towards <br> Success
            </span>
            ${btnBgLong}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
</div>`;

export const premium = `<div class="video-segments">
<div class="video-segment is-active segment-1" data-duration="27">
    <span class="video-segment_title">Prepare for Take-off</span>

    <div class="key-moment" data-timestamp="16">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-4.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-etienne-keymoment">
            ${keyMoment}
        </div>
    </div>
    <div class="interactive-point" data-timestamp="3" data-duration="5">
        <button type="button" class="btn-interactive" data-article-link data-article="premium" data-analytics="2024-sia-video-etienne-article">

            <span class="btn-interactive_text">
                Poised for <br>
                Perfection
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
<div class="video-segment" data-duration="28">
    <span class="video-segment_title">Connect to the World</span>

    <span class="key-moment" data-timestamp="31">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-5.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-etienne-keymoment">
            ${keyMoment}
        </div>
    </span>

    <div class="interactive-point" data-timestamp="44" data-duration="10">
        <button type="button" class="btn-interactive -culinary" data-video="culinary-btn"  data-analytics="2024-sia-video-etienne-culinary">
            <span class="btn-interactive_text">
                Culinary <br>
                Journey
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
<div class="video-segment" data-duration="11">
    <span class="video-segment_title">Cruise in Comfort</span>

    <div class="interactive-point" data-timestamp="56" data-duration="4">
        <button type="button" class="btn-interactive -culinary" data-video="aisle" data-type="premium"  data-analytics="2024-sia-video-etienne-aisle">
            <span class="btn-interactive_text text-center">
                Sky-High <br>
                Comforts
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>

    <span class="key-moment" data-timestamp="62">
        <div class="key-moment_thumbnail">
            <img src="img/thumbnails/t-6.jpg" class="object-cover w-full h-full" alt=""/>
        </div>
        <div class="key-moment_heart full-screen" data-analytics="2024-sia-video-etienne-keymoment">
            ${keyMoment}
        </div>
    </span>
</div>

<div class="video-segment segment-4" data-duration="9.69">
    <span class="video-segment_title">Experience Singapore Airlines </span>

    <div class="interactive-point" data-timestamp="70" data-duration="5">
        <button type="button" class="btn-interactive -article" data-article-link data-article="premium" data-analytics="2024-sia-video-etienne-article">

            <span class="btn-interactive_text">
                Poised for <br>
                Perfection
            </span>
            ${btnBg}
        </button>
        <div class="interactive-point_hover-support"></div>
        <span class="interactive-point_line"></span>
        <span class="interactive-point_inner">
    </div>
</div>
</div>`;
